<p-card class="p-3">
    <div class="commands-grid">
        @for (action of actions; track action.label) {
        <div class="cmd-card">
            <div class="cmd-icon-wrap" [class.cmd-icon-critical]="action.critical" [style.background]="action.iconBg">
                <img [src]="'assets/icons/' + action.icon" [alt]="action.label" class="panel-icon" />
            </div>
            <div class="cmd-info">
                <span class="cmd-name">{{ action.label }}</span>
                <span class="cmd-desc">{{ action.description }}</span>
            </div>
            <p-button label="Run" severity="primary" size="small" (onClick)="onAction(action)" />
        </div>
        }
    </div>
</p-card>

<!-- Confirm Command dialog -->
<p-dialog [(visible)]="confirmVisible" [style]="{ width: '26rem' }" [breakpoints]="{ '575px': '95vw' }"
    [closable]="false" [modal]="true" [draggable]="false" [dismissableMask]="true">

    <ng-template #header>
        <div class="confirm-header">
            <span class="confirm-title">Confirm Command</span>
            <button class="dialog-close" (click)="cancelAction()">
                <img src="assets/icons/fi_x.svg" alt="close" />
            </button>
        </div>
    </ng-template>

    @if (selectedAction) {
    <div class="confirm-body">
        <p class="confirm-cmd-name">{{ selectedAction.label }}</p>
        <p class="confirm-cmd-desc">{{ selectedAction.description }}</p>

        @if (selectedAction.critical) {
        <div class="confirm-warning">
            <i class="pi pi-exclamation-circle confirm-warning-icon"></i>
            <span><strong>Warning:</strong> This is a critical command that will immediately affect vehicle operation. Proceed with caution.</span>
        </div>
        }
    </div>
    }

    <ng-template #footer>
        <div class="confirm-footer">
            <p-button label="Cancel" variant="text" severity="secondary" (onClick)="cancelAction()" />
            <p-button label="Run" severity="primary" (onClick)="runAction()" />
        </div>
    </ng-template>

</p-dialog>
